import { render } from "./PeripheralConnection.vue?vue&type=template&id=1f00fdde&scoped=true&ts=true"
import script from "./PeripheralConnection.vue?vue&type=script&lang=ts"
export * from "./PeripheralConnection.vue?vue&type=script&lang=ts"

import "./PeripheralConnection.vue?vue&type=style&index=0&id=1f00fdde&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f00fdde"]])

export default __exports__